import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import styles from "./imageEditor.module.css";
import { useSelector } from "../../../../Redux";
import { uploadImageAPI } from "../../RequestLogic";
import { GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { loadArabicImage } from "../../IFormDesignerLogic";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10000,
    color: "#fff"
  }
}));

const aspectRatioOptions = [
  { label: "Manual", value: "auto" },
  { label: "1:1", value: "1 / 1" },
  { label: "3:2", value: "3 / 2" },
  { label: "4:3", value: "4 / 3" }
];

export default function ImageEditor(props) {
  const classes = useStyles();

  const contexts = GetStateFromData(props.containerId);
  const { updateJson, imageBaseURL, builderMode, activePage, activeSubForm, microFrontendData } = contexts.contexts;
  const { updatedComponentInFormState } = updateJson;
  const [editingToolOption, setEditingToolOption] = useState(
    props?.selectedControl?.elem_type === "imagecarousel" ? "Rotate and Flip" : "Crop Image"
  );
  const [selectedRotateFlipOption, setSelectedRotateFlipOption] = useState("");
  const [resizeOption, setResizeOption] = useState(
    props?.imageStyle?.resize === "dimension" ? "customResize" : "stretchToWidth"
  );
  const [widthType, setWidthType] = useState("percentage");
  const [imageDetails, setImageDetails] = useState({});
  const [image, setImage] = useState(`${imageBaseURL}${props.imageDetails.imageFile}${loadArabicImage(imageBaseURL)}`);
  const [imageStyle, setImageStyle] = useState(
    props.imageStyle
      ? props.imageStyle
      : {
          degree: 0,
          scaleX: 1,
          scaleY: 1,
          key: 1,
          transform: "rotate(0deg) scale(1,1)",
          aspectRatio: "auto",
          resizedWidthHeight: "100",
          widthType: props?.sectionCorouselBackground ? 'px' : "%"
        }
  );
  const [preImageStyle, setPreImageStyle] = useState(
    props.imageStyle
      ? props.imageStyle
      : {
          degree: 0,
          scaleX: 1,
          scaleY: 1,
          key: 1,
          transform: "rotate(0deg) scale(1,1)",
          aspectRatio: "auto",
          resizedWidthHeight: "100",
          widthType: props?.sectionCorouselBackground ? 'px' : "%"
        }
  );
  const [cropper, setCropper] = useState();
  function saveImage(arg) {
    if (arg === "cancel") {
      props.handleImageEditing("Cancel");
      setImageStyle((prev) => {
        return { ...preImageStyle };
      });
      props.selectedControl.style.imageStyle = { ...preImageStyle };
    } else if (arg === "Save & Exit" && imageStyle.croppedImage && imageStyle.aspectRatio === "auto") {
      const isPortal = builderMode === "application";
      if (isPortal || activePage || activeSubForm) {
        const jsonToSend = {
          imageObject: imageStyle.croppedImage || "",
          isBase64: true,
          applicationName:
            microFrontendData?.processName ||
            microFrontendData?.applicationName ||
            microFrontendData?.processDefId ||
            "",
          formName:
            microFrontendData?.taskId ||
            microFrontendData?.formName ||
            activePage?.formName ||
            activeSubForm?.fragmentName ||
            microFrontendData?.formId ||
            microFrontendData?.formDefId ||
            ""
        };

        uploadImageAPI(jsonToSend)
          .then((response) => {
            props.handleImageEditing("Save", response.data, { ...imageStyle, croppedImage: response.data });
            props.selectedControl.style.imageStyle = { ...imageStyle, croppedImage: response.data };
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else {
        props.handleImageEditing("Save", imageStyle.croppedImage, imageStyle);
        props.selectedControl.style.imageStyle = { ...imageStyle };
      }
    } else if (arg === "Save & Exit") {
      props.handleImageEditing("Save2", "", imageStyle);
      props.selectedControl.style.imageStyle = { ...imageStyle };
    }

    updatedComponentInFormState(props.selectedControl.id, props.selectedControl);
    props.handleClose();
  }

  function resizeImage(resizedWidthHeight) {
    if (resizedWidthHeight == "stretchToWidth") {
      setImageStyle((prev) => {
        return { ...prev, resizedWidthHeight: "100", widthType: props?.sectionCorouselBackground ? 'px' : "%", resize: "fullWidth", width: "100" };
      });
      setResizeOption("stretchToWidth");
    } else {
      setImageStyle((prev) => {
        return {
          ...prev,
          resizedWidthHeight: resizedWidthHeight,
          resize: "custom",
          widthType: widthType === "px" ? "px" : "%"
        };
      });
      setResizeOption("customResize");
    }
  }

  function handleResizeImage(field, value) {
    setImageStyle((prev) => {
      return { ...prev, [field]: value, widthType: widthType === "px" ? "px" : "%" };
    });
  }

  function handleCropRatio(comboId) {
    let select = document.getElementById(comboId);
    let optionTag = select.options[select.selectedIndex];

    if (comboId === "cropRatio") {
      let width;
      let height;
      if (
        document.getElementById("aspectRatioImage") !== null &&
        document.getElementById("aspectRatioImage") !== undefined
      ) {
        width = document.getElementById("aspectRatioImage").offsetWidth;
        height = document.getElementById("aspectRatioImage").offsetHeight;
      }
      setImageStyle((prev) => {
        return { ...prev, aspectRatio: optionTag.value, width: width, height: height };
      });
    } else {
      setWidthType(optionTag.value);
      setImageStyle((prev) => {
        return { ...prev, widthType: optionTag.value, scale: optionTag.value === "%" ? "percentage" : "pixels" };
      });
    }
  }

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      setImageStyle((prev) => {
        return {
          ...prev,
          croppedImage: cropper?.getCroppedCanvas()?.toDataURL(),
          width: Math.floor(cropper.cropBoxData.width),
          height: Math.floor(cropper.cropBoxData.height)
        };
      });
    }
  };

  function rotateAndFlipImage(action, dir) {
    if (action === "rotate") {
      if (dir === "left") {
        setSelectedRotateFlipOption("RotateLeft");
        setImageStyle((prev) => {
          return {
            ...prev,
            degree: (imageStyle.degree - 90) % 360,
            transform:
              "rotate(" +
              ((imageStyle.degree - 90) % 360) +
              "deg)" +
              " scale(" +
              imageStyle.scaleX +
              "," +
              imageStyle.scaleY +
              ")"
          };
        });
      } else if (dir === "right") {
        setSelectedRotateFlipOption("RotateRight");
        setImageStyle((prev) => {
          return {
            ...prev,
            degree: (imageStyle.degree + 90) % 360,
            transform:
              "rotate(" +
              ((imageStyle.degree + 90) % 360) +
              "deg)" +
              " scale(" +
              imageStyle.scaleX +
              "," +
              imageStyle.scaleY +
              ")"
          };
        });
      }
    } else if (action === "flip") {
      if (dir === "horizontal") {
        setSelectedRotateFlipOption("FlipHorizontal");
        setImageStyle((prev) => {
          return {
            ...prev,
            scaleX: Math.sign(imageStyle.scaleX) === 1 ? -1 : 1,
            transform:
              "rotate(" +
              imageStyle.degree +
              "deg)" +
              " scale(" +
              (Math.sign(imageStyle.scaleX) === 1 ? -1 : 1) +
              "," +
              imageStyle.scaleY +
              ")"
          };
        });
      } else if (dir === "vertical") {
        setSelectedRotateFlipOption("FlipVertical");
        setImageStyle((prev) => {
          return {
            ...prev,
            scaleY: Math.sign(imageStyle.scaleY) === 1 ? -1 : 1,
            transform:
              "rotate(" +
              imageStyle.degree +
              "deg)" +
              " scale(" +
              imageStyle.scaleX +
              "," +
              (Math.sign(imageStyle.scaleY) === 1 ? -1 : 1) +
              ")"
          };
        });
      }
    }
  }

  useEffect(() => {
    if (props.selectedControl.style) {
      props.selectedControl.style["imageStyle"] = imageStyle;
    }
  }, [imageStyle]);

  function handleEscapeKey(e) {
    if (e.code === "Escape") {
      saveImage("cancel");
    }
  }
  useEffect(()=>{
    document.getElementById("imageEditorId")?.focus();
    
   },[])

  useEffect(() => {
    setImage(`${imageBaseURL}${props.imageDetails.imageFile}${loadArabicImage(imageBaseURL)}`);
  }, [props.imageDetails.imageFile]);

  return (
    <div>
      <Backdrop className={classes.backdrop} open={props.open} containerId={props.containerId}>
        <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} className={styles.backdropDiv} id="imageEditorId">
          <Row className={styles.backdropHeader}>{"Image Studio"}</Row>

          <Row className={styles.backdropBody}>
            <Col className={styles.backdropLeftBody}>
              <div className={styles.backdropLeftBodyHeading}> {"Editing Tools"} </div>
              {props?.selectedControl?.elem_type === "imagecarousel" ? null : (
                <Col
                  className={[
                    styles.editingToolOptions,
                    editingToolOption === "Crop Image" ? styles.selectedEditingToolOption : null
                  ].join(" ")}
                  onClick={() => setEditingToolOption("Crop Image")}
                >
                  <img
                    src={require("../../../../Icons/crop.svg").default}
                    onClick={() => setEditingToolOption("Crop Image")}
                    alt="Crop Icon"
                  />

                  <span
                    className={[
                      styles.editingToolOptionsText,
                      editingToolOption === "Crop Image" ? styles.selectedEditingToolOptionText : null
                    ].join(" ")}
                    onClick={() => setEditingToolOption("Crop Image")}
                  >
                    {"Crop Image"}
                  </span>
                </Col>
              )}

              <Col
                className={[
                  styles.editingToolOptions,
                  editingToolOption === "Rotate and Flip" ? styles.selectedEditingToolOption : null
                ].join(" ")}
                onClick={() => setEditingToolOption("Rotate and Flip")}
              >
                <img
                  src={require("../../../../Icons/Rotate.svg").default}
                  onClick={() => setEditingToolOption("Rotate and Flip")}
                  alt="Rotate Icon"
                />

                <span
                  className={[
                    styles.editingToolOptionsText,
                    editingToolOption === "Rotate and Flip" ? styles.selectedEditingToolOptionText : null
                  ].join(" ")}
                  onClick={() => setEditingToolOption("Rotate and Flip")}
                >
                  {"Flip"}
                </span>
              </Col>
            </Col>

            <Col className={styles.backdropCenterBody}>
              <div className={styles.backdropCenterBodyHeading}>
                {editingToolOption === "Rotate and Flip" ? "Flip" : editingToolOption}
              </div>

              {editingToolOption === "Resize Image" ? (
                <>
                  <div className={styles.resizeImageDiv}>
                    <input
                      aria-label={"Resize Image" } 
                      type="radio"
                      key={resizeOption}
                      name="imageDimension"
                      className={styles.resizeOptionInputRadio}
                      checked={resizeOption === "stretchToWidth" ? true : false}
                      onClick={() => resizeImage("stretchToWidth")}
                    />

                    <label
                      aria-label={"image Dimension"}
                      for="imageDimension"
                      className={styles.cropRatioText}
                      onClick={() => resizeImage("stretchToWidth")}
                    >
                      {"Stretch to Section's width"}
                    </label>
                  </div>

                  <div className={styles.resizeImageDiv}>
                    <input
                      aria-label={"Resize Image" } 
                      type="radio"
                      key={resizeOption}
                      name="imageDimension"
                      className={styles.resizeOptionInputRadio}
                      checked={resizeOption === "customResize" ? true : false}
                      onClick={() => resizeImage("customResize")}
                    />

                    <label
                     aria-label={"image Dimension"}
                      for="imageDimension"
                      className={styles.cropRatioText}
                      onClick={() => resizeImage("customResize")}
                    >
                      {"Image Dimension"}
                    </label>

                    {resizeOption === "customResize" ? (
                      <select
                        className={styles.resizeOptionInput + " " + styles.resizeOptionInputropdown}
                        id={"customResize"}
                        onChange={() => handleCropRatio("customResize")}
                        style={{ marginLeft: "auto" }}
                      >
                        <option value="%" selected={imageStyle.widthType === "%" ? true : false}>
                          {"Percentage"}
                        </option>
                        <option value="px" selected={imageStyle.widthType === "px" ? true : false}>
                          {"Pixel"}
                        </option>
                      </select>
                    ) : null}
                  </div>

                  {resizeOption === "customResize" ? (
                    imageStyle.scale === "pixels" ? (
                      <div>
                        <div className={styles.resizeImageDiv} key={widthType}>
                          <label aria-label={"image Width"} className={styles.cropRatioText} style={{ marginLeft: "17px" }}>
                            {"Width"}
                          </label>

                          <div className={styles.resizeOptionInput} key={widthType}>
                            <input
                              type="text"
                              aria-label={"Resize Image" } 
                              value={imageStyle.width}
                              className={styles.resizeOptionInputText}
                              onChange={(event) => handleResizeImage("width", event.target.value)}
                            />

                            <span className={styles.widthTypeSpan} key={imageStyle.widthType}>
                              {imageStyle.widthType === "px" ? "px" : "%"}
                            </span>
                          </div>
                        </div>
                        <div className={styles.resizeImageDiv} key={widthType}>
                          <label aria-label={"image Height"} className={styles.cropRatioText} style={{ marginLeft: "17px" }}>
                            {"Height"}
                          </label>

                          <div className={styles.resizeOptionInput} key={widthType}>
                            <input
                              type="text"
                              aria-label={"Image Height" } 
                              value={imageStyle.height}
                              className={styles.resizeOptionInputText}
                              onChange={(event) => handleResizeImage("height", event.target.value)}
                            />

                            <span className={styles.widthTypeSpan} key={imageStyle.widthType}>
                              {imageStyle.widthType === "px" ? "px" : "%"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={styles.resizeImageDiv} key={widthType}>
                        <input aria-label={"Image Size" }  type="radio" name="none" checked="false" className={styles.resizeOptionHiddenRadio} />

                        <label aria-label={"image Size"} className={styles.cropRatioText}>{"Image Size"} </label>

                        <div className={styles.resizeOptionInput} key={widthType}>
                          <input
                            type="text"
                            aria-label={"Image Size" } 
                            value={imageStyle.size}
                            className={styles.resizeOptionInputText}
                            onChange={(event) => handleResizeImage("size", event.target.value)}
                          />

                          <span className={styles.widthTypeSpan} key={imageStyle.widthType}>
                            {imageStyle.widthType === "px" ? "px" : "%"}
                          </span>
                        </div>
                      </div>
                    )
                  ) : null}

                  <div className={styles.resizeImageMessage}>
                    {"Images are auto-compressed for the best viewing experience."}
                  </div>
                </>
              ) : editingToolOption === "Crop Image" ? (
                <Col className={styles.cropImgCol}>
                  <div className={styles.cropRatioDiv}>
                    <div className={styles.cropImageDiv}>
                      <span className={styles.cropRatioText}>{"Crop Ratio"}</span>

                      <select
                        className={styles.cropRatioDropdown}
                        id={"cropRatio"}
                        onChange={() => handleCropRatio("cropRatio")}
                        value={imageStyle.aspectRatio}
                      >
                        {aspectRatioOptions.map((item) => (
                          <option
                            value={item.value}
                            key={item.value}
                            className={imageStyle.aspectRatio === item.value ? styles.selectedCropRatio : ""}
                          >
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className={styles.cropImageSize}>
                    <p className={styles.cropRatioText}>{"Image Size(px)"}</p>

                    <div className={styles.cropImageDiv}>
                      <div className={styles.cropImageDetails}>
                        <span className={styles.widthHeightSpan}>{"W :"}</span>
                        <span className={styles.widthHeightSpan}>{imageStyle.width}</span>
                        <span className={styles.verticalSeparator}></span>
                        <span className={styles.widthHeightSpan}>{"H :"}</span>
                        <span className={styles.widthHeightSpan}>{imageStyle.height}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              ) : editingToolOption === "Rotate and Flip" ? (
                <Col className={styles.rotateFlipCol}>
                  <div
                    className={[
                      styles.rotateFlipImgDiv,
                      selectedRotateFlipOption === "FlipHorizontal" ? styles.selectedRotateFlipOption : null
                    ].join(" ")}
                    onClick={() => rotateAndFlipImage("flip", "horizontal")}
                  >
                    {selectedRotateFlipOption === "FlipHorizontal" ? (
                      <img
                        src={require("../../../../Icons/fliphorizontalselected.svg").default}
                        onClick={() => rotateAndFlipImage("flip", "horizontal")}
                        alt="Flip Horizontal Icon"
                      />
                    ) : (
                      <img
                        src={require("../../../../Icons/fliphorizontal.svg").default}
                        onClick={() => rotateAndFlipImage("flip", "horizontal")}
                        alt="Flip Horizontal Icon"
                      />
                    )}

                    <div className={styles.tooltiptext}>{"Flip Horizontally"}</div>
                  </div>

                  <div
                    className={[
                      styles.rotateFlipImgDiv,
                      selectedRotateFlipOption === "FlipVertical" ? styles.selectedRotateFlipOption : null
                    ].join(" ")}
                    onClick={() => rotateAndFlipImage("flip", "vertical")}
                  >
                    {selectedRotateFlipOption === "FlipVertical" ? (
                      <img
                        src={require("../../../../Icons/flipverticalselected.svg").default}
                        onClick={() => rotateAndFlipImage("flip", "vertical")}
                        alt="Flip Vertical Icon"
                      />
                    ) : (
                      <img
                        src={require("../../../../Icons/flipvertical.svg").default}
                        onClick={() => rotateAndFlipImage("flip", "vertical")}
                        alt="Flip Vertical Icon"
                      />
                    )}

                    <div className={styles.tooltiptext}>{"Flip Vertically"}</div>
                  </div>
                </Col>
              ) : null}
            </Col>

            <Col className={styles.backdropRightBody}>
              {props.imageDetails && props.imageDetails.imageFile && editingToolOption === "Rotate and Flip" ? (
                <img
                  id="rotateFlipImage"
                  alt="Rotate Flip"
                  src={image}
                  key={imageDetails.key}
                  style={{
                    height: "100%",
                    transform: imageStyle.transform,
                    aspectRatio: imageStyle.aspectRatio,
                    margin: "auto"
                  }}
                />
              ) : props?.imageDetails?.imageFile &&
                editingToolOption === "Crop Image" &&
                imageStyle.aspectRatio === "auto" ? (
                <div onMouseOut={() => getCropData()} style={{ width: "100%", height: "100%" }}>
                  <Cropper
                    style={{ width: "100%", height: "100%", padding: "0px" }}
                    zoomTo={0}
                    initialAspectRatio={1}
                    preview=".img-preview"
                    src={image}
                    viewMode={1}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false}
                    onInitialized={(instance) => {
                      setCropper(instance);
                    }}
                  />
                </div>
              ) : props?.imageDetails?.imageFile && editingToolOption === "Crop Image" ? (
                <img
                  id="aspectRatioImage"
                  alt="Aspect Ratio"
                  src={image}
                  key={imageDetails.key}
                  style={{
                    height: "100%",
                    transform: imageStyle.transform,
                    aspectRatio: imageStyle.aspectRatio,
                    margin: "auto"
                  }}
                />
              ) : props?.imageDetails?.imageFile && editingToolOption === "Resize Image" ? (
                <img
                  id="resizedImage"
                  alt="Resize Icon"
                  key={imageStyle.resizedWidthHeight}
                  src={image}
                  style={{
                    width:
                      resizeOption === "customResize"
                        ? imageStyle.widthType === "px"
                          ? imageStyle.width + imageStyle.widthType
                          : imageStyle.size + imageStyle.widthType
                        : "100%",
                    height:
                      resizeOption === "customResize"
                        ? imageStyle.widthType === "px"
                          ? imageStyle.height + imageStyle.widthType
                          : imageStyle.size + imageStyle.widthType
                        : "auto",
                    transform: imageStyle.transform,
                    aspectRatio: imageStyle.aspectRatio,
                    margin: "auto"
                  }}
                />
              ) : null}
            </Col>
          </Row>

          <Row className={styles.backdropFooter}>
            <Button className={styles.cancelButton} onClick={() => saveImage("cancel")}>
              {"Cancel"}
            </Button>

            <Button className={styles.saveButton} onClick={() => saveImage("Save & Exit")}>
              {"Save & Exit"}
            </Button>
          </Row>
        </div>
      </Backdrop>
    </div>
  );
}
